import { AppState } from 'types/appState';
import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { reduceToNextDemoStackUrl } from 'reducers/demoStackUrlReducers';
import { reduceToNextAuthType } from 'reducers/authTypeReducers';
import { reduceToNextUser } from 'reducers/userReducers';
import { reduceToNextProdStackInfo } from 'reducers/prodStackInfoReducers';
import { createAppState } from 'utils/createAppState';
import { reduceToNextInvalidatedCacheFlags } from 'reducers/invalidatedCacheFlagsReducers';
import { reduceToNextProdStackManagerCurrentStep } from 'reducers/prodStackManagerStepReducers';
import { reduceToNextPersonalInfoFormValues } from 'reducers/personalInfoFormValuesReducers';
import { reduceToNextOrgInfoFormValues } from 'reducers/orgInfoFormValuesReducers';
import { reduceToNextPartnerManager } from 'reducers/partnerManagerReducers';
import { reduceToNextPartnerClientManager } from 'reducers/partnerClientManagerReducers';
import { reduceToNextPartnerDashboard } from 'reducers/partnerDashboardReducers';
import { reduceToNextGiroPaymentManager } from 'reducers/giroPaymentManagerReducers';
import { reduceToNextCardPaymentManager } from 'reducers/cardPaymentManagerReducers';
import { reduceToNextAppEnvironment } from './appEnvironmentReducers';

export const reduceToNextAppState = createReducer<AppState, AppEvent>(
  (prev, event) => {
    switch (event.name) {
      case 'SignOutPage__SignedOut':
      case 'AppErrorFallback__SignedOut':
      case 'ProdStackManager__SignedOut':
      case 'ProdStackManager__EmailConfirmed':
      case 'DemoStackManager__EmailConfirmed':
      case 'PartnerRegistrationManager__EmailConfirmed':
      case 'PartnerRegistrationManager__ProfileFormSubmitDidSucceed':
      case 'AuthProcess__AuthFailed':
        prev = createAppState();
    }

    return {
      invalidatedCacheFlags: reduceToNextInvalidatedCacheFlags(
        prev.invalidatedCacheFlags,
        event
      ),
      demoStackUrl: reduceToNextDemoStackUrl(prev.demoStackUrl, event),
      authType: reduceToNextAuthType(prev.authType, event),
      user: reduceToNextUser(prev.user, event),
      prodStackInfo: reduceToNextProdStackInfo(prev.prodStackInfo, event),
      prodStackManagerCurrentStep: reduceToNextProdStackManagerCurrentStep(
        prev.prodStackManagerCurrentStep,
        event
      ),
      personalInfoFormValues: reduceToNextPersonalInfoFormValues(
        prev.personalInfoFormValues,
        event
      ),
      orgInfoFormValues: reduceToNextOrgInfoFormValues(
        prev.orgInfoFormValues,
        event
      ),
      partnerManager: reduceToNextPartnerManager(prev.partnerManager, event),
      partnerClientManager: reduceToNextPartnerClientManager(
        prev.partnerClientManager,
        event
      ),
      partnerDashboard: reduceToNextPartnerDashboard(
        prev.partnerDashboard,
        event
      ),
      giroPaymentManager: reduceToNextGiroPaymentManager(
        prev.giroPaymentManager,
        event
      ),
      cardPaymentManager: reduceToNextCardPaymentManager(
        prev.cardPaymentManager,
        event
      ),
      environment: reduceToNextAppEnvironment(prev.environment, event),
    };
  },
  (diff, event) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(event, diff);
    }
  }
);
